module.exports = __webpack_public_path__ + "static/media/index-logos.dc3064cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index-logos.png
// module id = 82
// module chunks = 0